<template>
    <div ref="RegisteredBySubSeries" class="h-100" style="min-height: 500px;"></div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

export default {
  data () {
    return {
      chart: null
    }
	},
	props: ['filterUrl', 'category'],
  mounted () {
    this.createChart()
  },
  watch : {
    'filterUrl' : function () {
      this.loadData();
    }
  },
  methods: {
		loadData () {
      let length = this.chart.data.length;

      this.$http.get(`/api/h1/qr-registration/vehicle-mapping-summary/registered-by-sub-series/${this.category}?${this.filterUrl}`)
      .then((resp) => {
        var data = resp.data.data;
        this.chart.addData((data != null && data.length != 0) ? data : [{sub_series : 'No Data', count : 1}] , length)
      })
      .catch((err) => {
        console.log(err)
      })
		},
    createChart () {
      this.chart = am4core.create(this.$refs.RegisteredBySubSeries, am4charts.XYChart);

      var gradient2 = new am4core.LinearGradient();
      gradient2.addColor(am4core.color("#bdc3c7"));
      gradient2.addColor(am4core.color("#2c3e50"));

      // Create axes
      let categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "sub_series";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 30;
      categoryAxis.renderer.labels.template.rotation = 270;
      categoryAxis.title.text = `Series of ${this.category} Motor`

      let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.title.text = "No of QR Registered";

      // Create series
      let series2 = this.chart.series.push(new am4charts.ColumnSeries());
      series2.dataFields.valueY = "count";
      series2.dataFields.categoryX = "sub_series";
      series2.clustered = false;
      series2.name = "Actual";
      series2.columns.template.width = am4core.percent(50);
      series2.tooltipText = "Actual QR Registered For {categoryX}: [bold]{valueY}[/]";
      series2.columns.template.fill = gradient2;
      series2.strokeWidth = 0;

      //  let series3 = this.chart.series.push(new am4charts.LineSeries());
      // series3.dataFields.valueY = "average";
      // series3.dataFields.categoryX = "type";
      // series3.strokeWidth = 2;
      // series3.name = "Average Registered";
      // series3.tooltipText = "Average QR Registered For {name}: [bold]{valueY}[/]";
      // series3.tooltipColorSource = am4core.color("#000")
      // series3.tensionX = 0.8;
      // series3.showOnInit = true;

      let interfaceColors = new am4core.InterfaceColorSet();

      // let bullet = series3.bullets.push(new am4charts.Bullet());
      // bullet.width = 12;
      // bullet.height = 12;
      // bullet.horizontalCenter = "middle";
      // bullet.verticalCenter = "middle";
      
      // let triangle = bullet.createChild(am4core.Triangle);
      // triangle.stroke = interfaceColors.getFor("background");
      // triangle.strokeWidth = 2;
      // triangle.direction = "top";
      // triangle.width = 12;
      // triangle.height = 12;

      this.chart.cursor = new am4charts.XYCursor();
      // chart.cursor.lineX.disabled = true;
      // chart.cursor.lineY.disabled = true;

      // Add legend
      this.chart.legend = new am4charts.Legend();
    }
  }
}
</script>